import _ from 'lodash';
import {newInstallationGroupActionTypes as nigActionTypes } from './NewInstallationGroupActions';
import * as actionTypes from '../../../constants/actionTypes';
import * as editorNames from '../../../constants/editorNames';

const initialState = {
  newInstallationGroups: [],
  installationUnits: [],
  filterGroups: []
};

function processFilterGroup(fg) {
  let values = [...fg.values]
    , newValueList = []
    , childValueList = [];
  
  values.forEach(v => {
    if(v.parent_id)
      childValueList.push(v);
    else
      newValueList.push(v);
  });

  childValueList.forEach(cv => {
    let parentValue = _.find(newValueList, pv => pv.id == cv.parent_id);
    if(parentValue) {
      parentValue.items = parentValue.items || [];
      parentValue.items.push(cv);
    } else {
      newValueList.push(cv);
    }
  });

  fg.values = newValueList;
  return fg;
}

export default function newInstallationGroupReducer(state = initialState, action) {
  var newState = {...state};
  switch(action.type) {
    case nigActionTypes.LOAD:
      newState.filterGroups = [];
      if(action.payload.installationUnits && action.payload.installationUnits.length > 0) {
        newState.installationUnits = [...action.payload.installationUnits];
      }
      if(action.payload.filterGroups && action.payload.filterGroups.length > 0) {
        action.payload.filterGroups.forEach(fg => {
          newState.filterGroups.push(processFilterGroup(fg));
        });
      }
    break;
    case nigActionTypes.ADD:
      newState.newInstallationGroups.unshift({
        name: action.payload.name,
        customDisplayName: action.payload.name,
        customDescription: action.payload.description,
        customImageUrl: action.payload.image,
        installations: [],
        enabled: true,
        visible: true
      });
    break;
    case actionTypes.SAVE_TRANSIENT_UPDATES: 
      newState.newInstallationGroups = [];
    break;
    case actionTypes.POST_LOAD_STORED_TRANSIENT_UPDATES:
      let pending = _.map(action.payload.editor.updatedTypes[editorNames.INSTALLATION_GROUP], g => g);
      pending.forEach(p => {
        newState.newInstallationGroups.push({
          name: p.name,
          customDisplayName: p.name,
          customDescription: p.description,
          customImageUrl: p.image,
          enabled: p.enabled || true,
          visible: p.visible || true
        });
      });
    break;
  }

  //console.log("new installation group state", newState);
  return newState;
}
